declare global {
  interface Window {
    dataLayer: any[]
  }
}

// Pushes a confirmed lead submission into the GTM dataLayer. GTM is
// installed globally by useGoogleTagManager, so this only adds the event.
//
// `leadId` is used for both `lead_id` and `event_id` so downstream tags
// (e.g. Meta CAPI) can deduplicate the browser and server events.
export function trackFormSubmit({
  formId,
  pageUrl,
  leadId,
}: {
  formId: string
  pageUrl: string
  leadId: string
}) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'form_submission',
    form_id: formId,
    page_path: pageUrl,
    lead_id: leadId,
    event_id: leadId,
  })
}
